import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { memo } from 'react';
import { MoneyValueZeroFormatter } from './money-value-formatter';

interface CellBoldProps {
  children: string;
  tabIndex: number;
}

const Bold = styled('span')({
  textOverflow: 'ellipsis',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  color: 'inherit',
});

const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});

export const CellBoldWithTooltip = memo(function CellBoldText(
  props: CellBoldProps,
) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <NoMaxWidthTooltip
      disableFocusListener
      disableTouchListener
      disableInteractive
      title={props.children}
      placement={'bottom-start'}
      arrow
      enterDelay={0}
    >
      <Bold tabIndex={props.tabIndex} onClick={handleClick}>
        {props.children}
      </Bold>
    </NoMaxWidthTooltip>
  );
});

export const CellBold = memo(function CellBoldText(props: CellBoldProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Bold
      tabIndex={props.tabIndex}
      onClick={handleClick}
      sx={{
        fontFamily: 'monospace',
      }}
    >
      {props.children}
    </Bold>
  );
});

export function CellBoldRenderer(
  params: GridRenderCellParams<any, string, any>,
) {
  const value = params.value ?? '';

  return (
    <CellBoldWithTooltip tabIndex={params.tabIndex}>
      {value}
    </CellBoldWithTooltip>
  );
}

export function CellBoldMoneyRenderer(
  params: GridRenderCellParams<any, string, any>,
) {
  let value = params.value ?? '';
  value = MoneyValueZeroFormatter(parseFloat(value));

  return <CellBold tabIndex={params.tabIndex}>{value}</CellBold>;
}

export function CellBoldMoneyZeroRenderer(
  params: GridRenderCellParams<any, string, any>,
) {
  let value = params.value ?? '';
  value = MoneyValueZeroFormatter(parseFloat(value), false);

  return <CellBold tabIndex={params.tabIndex}>{value}</CellBold>;
}
